import React from 'react';
import * as LucideIcons from 'lucide-react';
import { features } from '../../data/mock';

const Features = () => {
  return (
    <section id="features" className="relative py-24 lg:py-32 bg-slate-50 dark:bg-slate-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 dark:text-white mb-4">
            Core Capabilities
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-400">
            From process automation to analytics, TradeEngine.AI streamlines every aspect of enterprise operations.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => {
            const Icon = LucideIcons[feature.icon];
            return (
              <div
                key={feature.id}
                className="group p-6 bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 hover:border-slate-300 dark:hover:border-slate-700 transition-all duration-300"
              >
                {/* Icon */}
                <div className="w-10 h-10 rounded-lg bg-slate-100 dark:bg-slate-800 flex items-center justify-center mb-5">
                  {Icon && <Icon className="w-5 h-5 text-slate-600 dark:text-slate-400 group-hover:text-orange-500 transition-colors" />}
                </div>

                {/* Content */}
                <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">
                  {feature.title}
                </h3>
                <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
